import { FC } from 'react';
import { noop } from 'lodash-es';
import { theme } from '@frontend/theme';
import { RadioField as DSRadioField, FieldChangeEvent } from '@frontend/design-system';

interface InlineRadioFieldProps {
  options: Array<{ label: string; value: string }>;
  fieldId: string;
  value: string;
  hasError: boolean;
  onChange: (e?: FieldChangeEvent) => void;
  onBlur: () => void;
}

export const InlineRadioField: FC<InlineRadioFieldProps> = ({
  options,
  fieldId,
  value,
  hasError,
  onChange,
  onBlur,
}) => {
  return (
    <DSRadioField
      id={fieldId}
      name={fieldId}
      label=''
      value={value}
      error=''
      touched={false}
      active={false}
      aria-invalid={hasError}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={noop}
      css={{ gap: theme.spacing(1), display: 'flex', flexDirection: 'column' }}
    >
      {options.map((option) => (
        <DSRadioField.Radio css={{ margin: theme.spacing(0, 0, 0, 0.5) }} key={option.value} value={option.value}>
          {option.label}
        </DSRadioField.Radio>
      ))}
    </DSRadioField>
  );
};
